import { mediumGrey } from '@styles/theme';
import { style } from '@vanilla-extract/css';

export const container = style({
  padding: '0.25rem', // 4px
});

export const row = style({
  display: 'flex',
  alignItems: 'center',
  gap: '0.5rem', // 8px
});

export const bar = style({
  flex: 1,
});

export const secured = style({
  display: 'flex',
  alignItems: 'center',
  gap: '0.25rem', // 4px
  flexShrink: 0,
});

export const label = style({
  display: 'none',
  fontSize: '0.625rem', // 10px
  color: mediumGrey,
  '@media': {
    'screen and (min-width: 48em)': {
      display: 'inline',
    },
  },
});
